import { render } from "./DeleteFamilyGroup.vue?vue&type=template&id=7e4e29dc"
import script from "./DeleteFamilyGroup.vue?vue&type=script&lang=js"
export * from "./DeleteFamilyGroup.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__